import React from 'react';
import { useSpring, animated } from '@react-spring/web';
import { useNavigate } from 'react-router-dom';
import './OurPurpose.css';
import ImpactPartners from '../../components/OurPurpose/ImpactPartners';
import empowermentImage from '../../assets/images/impact-image.jpg';
import programImage from '../../assets/images/purpose-image-2.jpeg';

const OurPurpose = () => {
  const navigate = useNavigate();

  // Define the bounceIn animation for the text content and button
  const bounceIn = useSpring({
    from: { opacity: 0, transform: 'translateY(-50px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: { tension: 150, friction: 25 },
  });

  const handleConnectClick = () => {
    navigate('/lets-talk');
  };

  return (
    <div className="our-purpose-container">
      <section className="our-purpose-wrapper">
        <div className="container">
          <div className="page-our-purpose-container">
            <animated.div
              style={bounceIn}
              className="page-text-content-container"
            >
              {/* First Section - Main Content */}
              <div className="page-text-content page-main-section">
                <h1 className="page-our-purpose-heading">
                  TO IMPROVE LIVES BY <br />
                  <span className="page-highlight">
                    {' '}
                    RE-DEFINING ADVERTISING
                  </span>
                </h1>
                <p className="page-purpose-text">
                  Our mission is to drive positive social impact by providing a
                  new way to monetize Everyday content.
                </p>
                <p className="page-purpose-text">
                  To enable a more socially and morally responsible way of
                  advertising by driving more ethical investments for
                  advertisers.
                </p>
                <div className="page-connect-button-container">
                  <button
                    onClick={handleConnectClick}
                    className="page-connect-button"
                  >
                    LET'S CONNECT
                  </button>
                </div>
              </div>

              {/* Second Section - Creator Empowerment Text */}
              <div className="page-additional-content-text-section page-creator-empowerment-section">
                <div className="page-additional-content-text">
                  <p className="page-additional-text">
                    The goal is to empower creators - both within and beyond EDC
                    - to spark creativity, elevate their content creation
                    skills, and unlock new earning opportunities.
                  </p>
                  <p className="page-additional-text">
                    Through training, mentorship, and access to real brand
                    collaborations, we're fostering a more inclusive digital
                    economy where creativity becomes a sustainable livelihood,
                    driving both personal and community impact.
                  </p>
                </div>
              </div>

              {/* Impact Partners - Separate Section */}
              <div className="page-impact-partners-section">
                <ImpactPartners />
              </div>

              {/* First Image - Creator Empowerment */}
              <div className="page-creator-empowerment-image-container page-first-image">
                <div className="page-creator-empowerment-image-outline">
                  <div className="page-creator-empowerment-image">
                    <img src={empowermentImage} alt="Creator Empowerment" />
                  </div>
                </div>
              </div>

              {/* Third Section - R0-Income Program Text */}
              <div className="page-additional-content-text-section page-program-section">
                <div className="page-additional-content-text">
                  <h2 className="page-unemployment-program-heading">
                    TACKLING UNEMPLOYMENT THROUGH OUR R0-INCOME PROGRAMME
                  </h2>
                  <p className="page-additional-text">
                    A program designed to address unemployment by moving
                    Creators from knowledge to implementation.
                  </p>
                  <p className="page-additional-text">
                    We empower unemployed individuals by equipping them with the
                    skills, training, and support needed to create content for
                    monetization.
                  </p>
                  <p className="page-additional-text">
                    Throughout the program, we track their progress in both
                    content creation and earnings. After completion, they can
                    continue earning through EDC, applying the skills they've
                    developed to unlock sustainable opportunities.
                  </p>
                </div>
              </div>

              {/* Second Image - R0-Income Program */}
              <div className="page-r0-income-program-image-container page-second-image">
                <div className="page-r0-income-program-image-outline">
                  <div className="page-r0-income-program-image">
                    <img src={programImage} alt="R0-Income Program" />
                  </div>
                </div>
              </div>
            </animated.div>
          </div>
        </div>
      </section>
      <div className="footer-separator" />
    </div>
  );
};

export default OurPurpose;
